import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  translations: Record<string, string> = {};
  private http = inject(HttpClient);

  loadTranslations(): Observable<Record<string, string>> {
    return this.http.get<Record<string, string>>('/assets/i18n/translation_de_DE.json').pipe(
      tap((response: Record<string, string>) => {
        this.translations = response;
      })
    );
  }

  setTranslations(translations: Record<string, string>) {
    this.translations = translations;
  }

  translate(key: string): string {
    return this.translations[key] || key;
  }

  getSubset(keyPrefix: string): Record<string, string> {
    const result: Record<string, string> = {};

    for (const key in this.translations) {
      if (keyPrefix && keyPrefix.length > 0 && key.startsWith(keyPrefix)) {
        result[key] = this.translations[key];
      }
    }

    return result;
  }
}
